module.exports = {
      id: "bundle-usage",
      viewBox: "0 0 15.204 15.204",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#bundle",
      toString: function () {
        return this.url;
      }
    }